import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import "./Navbar.css";
import "./loading.css";
import { checkUserRole, signOut } from "../../store/actions/authActions";
import NavbarSearch from "./NavbarSearch";
import Media from "react-media";
import {
  Modal,
  TransitionablePortal,
  Container,
  Icon,
  Menu,
  Sidebar,
  Button,
  Input,
} from "semantic-ui-react";
import JoinCsaForm from "./JoinCsaForm";

var searchBar = null;
var pusher = null;

var athleteList = null;

var searchPortal = null;
const animation = "scale";
const duration = 500;

const NavBarMobile = (props) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const {
    children,
    onPusherClick,
    onToggle,
    onSearchClick,
    rightItems,
    visible,
    signedIn,
    hamburgerSignedIn,
    hamburgerSignedOut,
  } = props;

  if (visible) {
    document.body.style.overflow = "hidden";

    pusher = (
      <Sidebar.Pusher
        dimmed={visible}
        onClick={onPusherClick}
        style={{ minHeight: "100vh" }}
      >
        <Menu secondary fixed="top">
          <Menu.Item>
            <div className="NavbarGroup">
              <Link to="/" className="NavbarLogo">
                <img
                  src={require("../../images/csaLogo3.svg").default}
                  alt="CSA Logo"
                />
              </Link>
            </div>
          </Menu.Item>
        </Menu>
        {children}
      </Sidebar.Pusher>
    );
  } else {
    document.body.style.overflow = "unset";

    pusher = (
      <Sidebar.Pusher
        dimmed={visible}
        onClick={onPusherClick}
        style={{ height: "82px" }}
      >
        <Menu secondary fixed="top">
          <Menu.Item>
            <div className="NavbarGroup">
              <Link to="/" className="NavbarLogo">
                <img
                  src={require("../../images/csaLogo3.svg").default}
                  alt="CSA Logo"
                />
              </Link>
            </div>
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item>{rightItems}</Menu.Item>
            <Menu.Item position="right" onClick={onSearchClick}>
              <Icon name="search" className="mr-0" />
            </Menu.Item>
            <Menu.Item onClick={onToggle}>
              <Icon name="sidebar" className="mr-0" />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        {children}
      </Sidebar.Pusher>
    );
  }
  if (signedIn) {
    if (currentPath.includes("/updatehistory")) {
      return null;
    } else {
      return (
        <Sidebar.Pushable>
          <Sidebar
            as={Menu}
            animation="overlay"
            icon="labeled"
            vertical
            visible={visible}
            direction="right"
          >
            {hamburgerSignedIn}
          </Sidebar>
          {pusher}
        </Sidebar.Pushable>
      );
    }
  } else {
    if (currentPath.includes("/updatehistory")) {
      return null;
    } else {
      return (
        <Sidebar.Pushable>
          <Sidebar
            as={Menu}
            animation="overlay"
            icon="labeled"
            vertical
            visible={visible}
            direction="right"
          >
            {hamburgerSignedOut}
          </Sidebar>
          {pusher}
        </Sidebar.Pushable>
      );
    }
  }
};

const NavBarChildren = (props) => (
  <Container style={{ marginTop: "5em" }}>{props.children}</Container>
);

const Navbar = (props) => {
  const [visible, setVisible] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [search, setSearch] = useState(false);
  const [key, setKey] = useState(Date.now());
  const [joinCsaClicked, setjoinCsaClicked] = useState(false);
  const [searchIcon, setSearchIcon] = useState("search");
  const location = useLocation();
  const [hasScrolled, setHasScrolled] = useState(false);
  const currentPath = location.pathname;

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const scrollTop = window.pageYOffset;

      if (scrollTop > 50) {
        setHasScrolled(true);
      } else {
        setHasScrolled(false);
      }
    });
  }, []);

  const handlePusher = () => {
    if (visible) setVisible(false);
  };

  const handleToggle = () => setVisible(!visible);

  const handleClick = () => {
    setIsSearching(true);
  };

  const handleButtonClick = () => {
    if (visible) {
      setVisible(false);
      setjoinCsaClicked(true);
    } else {
      setjoinCsaClicked(true);
    }
  };

  const handleJoinCsaClose = () => {
    setjoinCsaClicked(false);
  };

  const handleClose = () => {
    setIsSearching(false);
    setSearch("");
    setSearchIcon("search");
    updateKey();
  };

  const handleCloseClick = () => {
    setSearch("");
    setSearchIcon("search");
    updateKey();
  };

  const handleOnChange = (e) => {
    setSearch(e.target.value);
    if (e.target.value === "") {
      setSearchIcon("search");
      updateKey();
    } else {
      setSearchIcon(<Icon name="close" link onClick={handleCloseClick} />);
    }
  };

  const updateKey = () => {
    setKey(Date.now());
  };

  const handleAthleteClick = () => {
    handleClose();
  };

  const handleSignOut = () => {
    props.signOut();
    setVisible(false);
  };

  const handleSideBar = () => {
    setVisible(false);
  };

  const buttonText = "Contact CSA!";
  var hamburgerSignedIn = null;
  var hamburgerSignedOut = null;

  const joinCsaButton = (
    <Button positive fluid name="joinCsaButton" onClick={handleButtonClick}>
      {buttonText}
    </Button>
  );

  var signedInLinks = null;

  const { children, leftItems, rightItems } = props;

  searchBar = (
    <Input
      fluid
      key={key}
      icon={searchIcon}
      placeholder="Search Athletes..."
      name="filteredSearch"
      onChange={handleOnChange}
    />
  );

  if (search !== "") {
    athleteList = (
      <NavbarSearch
        filteredSearch={search}
        isSearching={isSearching}
        navBarSearchClick={handleAthleteClick}
      />
    );
  } else {
    athleteList = null;
  }

  searchPortal = (
    <TransitionablePortal
      transition={{ animation, duration }}
      open={isSearching}
      onClose={handleClose}
    >
      <Modal onClose={handleClose} open={true}>
        <Modal.Content>
          {searchBar}
          {athleteList}
        </Modal.Content>
      </Modal>
    </TransitionablePortal>
  );

  const athletesLink = <Link to={`/athletes`}>Athletes</Link>;
  const commitmentsLink = <Link to={`/commitments`}>Commitments</Link>;
  const eventsLink = <Link to={`/events`}>Events</Link>;
  const playlistLink = <Link to={`/playlists`}>Skills</Link>;

  const signedOutLinks = (
    <Media
      queries={{
        mobile: "(max-width: 599px)",
        small: "(min-width: 600px) and (max-width: 699px)",
        medium: "(min-width: 700px) and (max-width: 899px)",
        large: "(min-width: 900px)",
      }}
    >
      {(matches) => (
        <Fragment>
          {matches.mobile && null}
          {matches.small && (
            <div className="SignedOutLinksOne">
              <div className="NavButtonGroup">
                {joinCsaButton}
                <JoinCsaForm
                  joinCsa={joinCsaClicked}
                  joinCsaClose={handleJoinCsaClose}
                />
              </div>
            </div>
          )}
          {matches.medium && (
            <div className="SignedOutLinksTwo">
              {athletesLink}
              <div className="NavButtonGroup">
                {joinCsaButton}
                <JoinCsaForm
                  joinCsa={joinCsaClicked}
                  joinCsaClose={handleJoinCsaClose}
                />
              </div>
            </div>
          )}
          {matches.large && (
            <div className="SignedOutLinksFour">
              {athletesLink}
              {commitmentsLink}
              {eventsLink}
              <div className="NavButtonGroup">
                {joinCsaButton}
                <JoinCsaForm
                  joinCsa={joinCsaClicked}
                  joinCsaClose={handleJoinCsaClose}
                />
              </div>
            </div>
          )}
        </Fragment>
      )}
    </Media>
  );

  hamburgerSignedOut = (
    <Media
      queries={{
        mobile: "(max-width: 599px)",
        small: "(min-width: 600px) and (max-width: 699px)",
        medium: "(min-width: 700px) and (max-width: 899px)",
        large: "(min-width: 900px)",
      }}
    >
      {(matches) => (
        <Fragment>
          {matches.mobile && [
            <Menu.Item key="joinCsa">
              {joinCsaButton}
              <JoinCsaForm
                joinCsa={joinCsaClicked}
                joinCsaClose={handleJoinCsaClose}
              />
            </Menu.Item>,
            <Menu.Item key="athletes">
              <Link to="/athletes" onClick={handleSideBar}>
                Athletes
              </Link>
            </Menu.Item>,
            <Menu.Item key="commitments">
              <Link to="/commitments" onClick={handleSideBar}>
                Commitments
              </Link>
            </Menu.Item>,
            <Menu.Item key="events">
              <Link to="/events" onClick={handleSideBar}>
                Events
              </Link>
            </Menu.Item>,
            <Menu.Item key="playlists">
              <Link to="/playlists" onClick={handleSideBar}>
                Skills
              </Link>
            </Menu.Item>,
            <Menu.Item key="about">
              <Link to="/about" onClick={handleSideBar}>
                About
              </Link>
            </Menu.Item>,
            <Menu.Item key="partners">
              <Link to="/partners" onClick={handleSideBar}>
                Partners
              </Link>
            </Menu.Item>,
            <Menu.Item key="testimonials">
              <Link to="/testimonials" onClick={handleSideBar}>
                Testimonials
              </Link>
            </Menu.Item>,
            <Menu.Item key="media">
              <Link to="/media" onClick={handleSideBar}>
                Media
              </Link>
            </Menu.Item>,
            <Menu.Item key="contact">
              <Link to="/contact" onClick={handleSideBar}>
                Contact
              </Link>
            </Menu.Item>,
            <Menu.Item key="login">
              <Link to="/login" onClick={handleSideBar}>
                Login
              </Link>
            </Menu.Item>,
            <Menu.Item key="signup">
              <Link to="/signup" onClick={handleSideBar}>
                Signup
              </Link>
            </Menu.Item>,
          ]}
          {matches.small && [
            <Menu.Item key="athletes">
              <Link to="/athletes" onClick={handleSideBar}>
                Athletes
              </Link>
            </Menu.Item>,
            <Menu.Item key="commitments">
              <Link to="/commitments" onClick={handleSideBar}>
                Commitments
              </Link>
            </Menu.Item>,
            <Menu.Item key="events">
              <Link to="/events" onClick={handleSideBar}>
                Events
              </Link>
            </Menu.Item>,
            <Menu.Item key="playlists">
              <Link to="/playlists" onClick={handleSideBar}>
                Skills
              </Link>
            </Menu.Item>,
            <Menu.Item key="about">
              <Link to="/about" onClick={handleSideBar}>
                About
              </Link>
            </Menu.Item>,
            <Menu.Item key="partners">
              <Link to="/partners" onClick={handleSideBar}>
                Partners
              </Link>
            </Menu.Item>,
            <Menu.Item key="testimonials">
              <Link to="/testimonials" onClick={handleSideBar}>
                Testimonials
              </Link>
            </Menu.Item>,
            <Menu.Item key="media">
              <Link to="/media" onClick={handleSideBar}>
                Media
              </Link>
            </Menu.Item>,
            <Menu.Item key="contact">
              <Link to="/contact" onClick={handleSideBar}>
                Contact
              </Link>
            </Menu.Item>,
            <Menu.Item key="login">
              <Link to="/login" onClick={handleSideBar}>
                Login
              </Link>
            </Menu.Item>,
            <Menu.Item key="signup">
              <Link to="/signup" onClick={handleSideBar}>
                Signup
              </Link>
            </Menu.Item>,
          ]}
          {matches.medium && [
            <Menu.Item key="commitments">
              <Link to="/commitments" onClick={handleSideBar}>
                Commitments
              </Link>
            </Menu.Item>,
            <Menu.Item key="events">
              <Link to="/events" onClick={handleSideBar}>
                Events
              </Link>
            </Menu.Item>,
            <Menu.Item key="playlists">
              <Link to="/playlists" onClick={handleSideBar}>
                Skills
              </Link>
            </Menu.Item>,
            <Menu.Item key="about">
              <Link to="/about" onClick={handleSideBar}>
                About
              </Link>
            </Menu.Item>,
            <Menu.Item key="partners">
              <Link to="/partners" onClick={handleSideBar}>
                Partners
              </Link>
            </Menu.Item>,
            <Menu.Item key="testimonials">
              <Link to="/testimonials" onClick={handleSideBar}>
                Testimonials
              </Link>
            </Menu.Item>,
            <Menu.Item key="media">
              <Link to="/media" onClick={handleSideBar}>
                Media
              </Link>
            </Menu.Item>,
            <Menu.Item key="contact">
              <Link to="/contact" onClick={handleSideBar}>
                Contact
              </Link>
            </Menu.Item>,
            <Menu.Item key="login">
              <Link to="/login" onClick={handleSideBar}>
                Login
              </Link>
            </Menu.Item>,
            <Menu.Item key="signup">
              <Link to="/signup" onClick={handleSideBar}>
                Signup
              </Link>
            </Menu.Item>,
          ]}
          {matches.large && [
            <Menu.Item key="about">
              <Link to="/about" onClick={handleSideBar}>
                About
              </Link>
            </Menu.Item>,
            <Menu.Item key="skills">
              <Link to="/playlists" onClick={handleSideBar}>
                Skills
              </Link>
            </Menu.Item>,
            <Menu.Item key="partners">
              <Link to="/partners" onClick={handleSideBar}>
                Partners
              </Link>
            </Menu.Item>,
            <Menu.Item key="testimonials">
              <Link to="/testimonials" onClick={handleSideBar}>
                Testimonials
              </Link>
            </Menu.Item>,
            <Menu.Item key="media">
              <Link to="/media" onClick={handleSideBar}>
                Media
              </Link>
            </Menu.Item>,
            <Menu.Item key="contact">
              <Link to="/contact" onClick={handleSideBar}>
                Contact
              </Link>
            </Menu.Item>,
            <Menu.Item key="login">
              <Link to="/login" onClick={handleSideBar}>
                Login
              </Link>
            </Menu.Item>,
            <Menu.Item key="signup">
              <Link to="/signup" onClick={handleSideBar}>
                Signup
              </Link>
            </Menu.Item>,
          ]}
        </Fragment>
      )}
    </Media>
  );

  const { auth, superAdmin } = props;

  var adminLink = null;
  var hamburgerAdminLink = null;

  if (superAdmin !== null) {
    if (superAdmin) {
      adminLink = <Link to={`/super-admin`}>Admin</Link>;
      hamburgerAdminLink = (
        <Link to="/super-admin" onClick={handleSideBar}>
          Admin
        </Link>
      );
    } else {
      adminLink = <Link to={`/admin/` + auth.uid}>Admin</Link>;
      hamburgerAdminLink = (
        <Link to={`/admin/` + auth.uid} onClick={handleSideBar}>
          Admin
        </Link>
      );
    }
  }

  if (auth.uid) {
    signedInLinks = (
      <div>
        <Media
          queries={{
            mobile: "(max-width: 599px)",
            small: "(min-width: 600px) and (max-width: 699px)",
            medium: "(min-width: 700px) and (max-width: 899px)",
            large: "(min-width: 900px)",
          }}
        >
          {(matches) => (
            <Fragment>
              {matches.mobile && null}
              {matches.small && (
                <div className="SignedInLinksOne">{adminLink}</div>
              )}
              {matches.medium && (
                <div className="SignedInLinksTwo">
                  {athletesLink}
                  {adminLink}
                </div>
              )}
              {matches.large && (
                <div className="SignedInLinksFour">
                  {athletesLink}
                  {commitmentsLink}
                  {eventsLink}
                  {adminLink}
                </div>
              )}
            </Fragment>
          )}
        </Media>
      </div>
    );
  } else {
    signedInLinks = null;
  }

  hamburgerSignedIn = (
    <Media
      queries={{
        mobile: "(max-width: 599px)",
        small: "(min-width: 600px) and (max-width: 699px)",
        medium: "(min-width: 700px) and (max-width: 899px)",
        large: "(min-width: 900px)",
      }}
    >
      {(matches) => (
        <Fragment>
          {matches.mobile && [
            <Menu.Item key="admin">{hamburgerAdminLink}</Menu.Item>,
            <Menu.Item key="athletes">
              <Link to="/athletes" onClick={handleSideBar}>
                Athletes
              </Link>
            </Menu.Item>,
            <Menu.Item key="commitments">
              <Link to="/commitments" onClick={handleSideBar}>
                Commitments
              </Link>
            </Menu.Item>,
            <Menu.Item key="events">
              <Link to="/events" onClick={handleSideBar}>
                Events
              </Link>
            </Menu.Item>,
            <Menu.Item key="playlists">
              <Link to="/playlists" onClick={handleSideBar}>
                Skills
              </Link>
            </Menu.Item>,
            <Menu.Item key="about">
              <Link to="/about" onClick={handleSideBar}>
                About
              </Link>
            </Menu.Item>,
            <Menu.Item key="partners">
              <Link to="/partners" onClick={handleSideBar}>
                Partners
              </Link>
            </Menu.Item>,
            <Menu.Item key="testimonials">
              <Link to="/testimonials" onClick={handleSideBar}>
                Testimonials
              </Link>
            </Menu.Item>,
            <Menu.Item key="media">
              <Link to="/media" onClick={handleSideBar}>
                Media
              </Link>
            </Menu.Item>,
            <Menu.Item key="contact">
              <Link to="/contact" onClick={handleSideBar}>
                Contact
              </Link>
            </Menu.Item>,
            <Menu.Item key="logout">
              <Link to="/login" onClick={handleSignOut}>
                Log Out
              </Link>
            </Menu.Item>,
          ]}
          {matches.small && [
            <Menu.Item key="athletes">
              <Link to="/athletes" onClick={handleSideBar}>
                Athletes
              </Link>
            </Menu.Item>,
            <Menu.Item key="commitments">
              <Link to="/commitments" onClick={handleSideBar}>
                Commitments
              </Link>
            </Menu.Item>,
            <Menu.Item key="events">
              <Link to="/events" onClick={handleSideBar}>
                Events
              </Link>
            </Menu.Item>,
            <Menu.Item key="playlists">
              <Link to="/playlists" onClick={handleSideBar}>
                Skills
              </Link>
            </Menu.Item>,
            <Menu.Item key="about">
              <Link to="/about" onClick={handleSideBar}>
                About
              </Link>
            </Menu.Item>,
            <Menu.Item key="partners">
              <Link to="/partners" onClick={handleSideBar}>
                Partners
              </Link>
            </Menu.Item>,
            <Menu.Item key="testimonials">
              <Link to="/testimonials" onClick={handleSideBar}>
                Testimonials
              </Link>
            </Menu.Item>,
            <Menu.Item key="media">
              <Link to="/media" onClick={handleSideBar}>
                Media
              </Link>
            </Menu.Item>,
            <Menu.Item key="contact">
              <Link to="/contact" onClick={handleSideBar}>
                Contact
              </Link>
            </Menu.Item>,
            <Menu.Item key="logout">
              <Link to="/login" onClick={handleSignOut}>
                Log Out
              </Link>
            </Menu.Item>,
          ]}
          {matches.medium && [
            <Menu.Item key="commitments">
              <Link to="/commitments" onClick={handleSideBar}>
                Commitments
              </Link>
            </Menu.Item>,
            <Menu.Item key="events">
              <Link to="/events" onClick={handleSideBar}>
                Events
              </Link>
            </Menu.Item>,
            <Menu.Item key="playlists">
              <Link to="/playlists" onClick={handleSideBar}>
                Skills
              </Link>
            </Menu.Item>,
            <Menu.Item key="about">
              <Link to="/about" onClick={handleSideBar}>
                About
              </Link>
            </Menu.Item>,
            <Menu.Item key="partners">
              <Link to="/partners" onClick={handleSideBar}>
                Partners
              </Link>
            </Menu.Item>,
            <Menu.Item key="testimonials">
              <Link to="/testimonials" onClick={handleSideBar}>
                Testimonials
              </Link>
            </Menu.Item>,
            <Menu.Item key="media">
              <Link to="/media" onClick={handleSideBar}>
                Media
              </Link>
            </Menu.Item>,
            <Menu.Item key="contact">
              <Link to="/contact" onClick={handleSideBar}>
                Contact
              </Link>
            </Menu.Item>,
            <Menu.Item key="logout">
              <Link to="/login" onClick={handleSignOut}>
                Log Out
              </Link>
            </Menu.Item>,
          ]}
          {matches.large && [
            <Menu.Item key="about">
              <Link to="/about" onClick={handleSideBar}>
                About
              </Link>
            </Menu.Item>,
            <Menu.Item key="partners">
              <Link to="/partners" onClick={handleSideBar}>
                Partners
              </Link>
            </Menu.Item>,
            <Menu.Item key="Skllls">
              <Link to="/playlists" onClick={handleSideBar}>
                Skills
              </Link>
            </Menu.Item>,
            <Menu.Item key="testimonials">
              <Link to="/testimonials" onClick={handleSideBar}>
                Testimonials
              </Link>
            </Menu.Item>,
            <Menu.Item key="media">
              <Link to="/media" onClick={handleSideBar}>
                Media
              </Link>
            </Menu.Item>,
            <Menu.Item key="contact">
              <Link to="/contact" onClick={handleSideBar}>
                Contact
              </Link>
            </Menu.Item>,
            <Menu.Item key="logout">
              <Link to="/login" onClick={handleSignOut}>
                Log Out
              </Link>
            </Menu.Item>,
          ]}
        </Fragment>
      )}
    </Media>
  );

  const links = auth.uid ? signedInLinks : signedOutLinks;

  var signedIn = null;

  if (auth.uid) {
    signedIn = true;
  } else {
    signedIn = false;
  }

  if (auth.isLoaded) {
    if (auth.uid) {
      props.checkUserRole();
    }
    if (currentPath.includes("/updatehistory")) {
      return null;
    } else {
      return (
        <div className={hasScrolled ? "Navbar NavbarScrolled" : "Navbar"}>
          <Fragment>
            <NavBarMobile
              onPusherClick={handlePusher}
              onToggle={handleToggle}
              onSearchClick={handleClick}
              rightItems={links}
              visible={visible}
              signedIn={signedIn}
              onSignOut={handleSignOut}
              onClick={handleSideBar}
              hamburgerSignedIn={hamburgerSignedIn}
              hamburgerSignedOut={hamburgerSignedOut}
            >
              <NavBarChildren>{children}</NavBarChildren>
              {searchPortal}
            </NavBarMobile>
          </Fragment>
        </div>
      );
    }
  } else {
    return null;
  }
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkUserRole: () => dispatch(checkUserRole()),
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
